import React from 'react'

export default function About() {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2>About Me</h2>
        <div className="about-text">
          <p>
            Some people separate work and life. I&apos;ve never really managed
            that and I&apos;ve stopped trying. I take systems apart to
            understand how they work, then put them back together in ways that
            create real value. That&apos;s true whether I&apos;m leading a cloud
            transformation, building a developer platform, or figuring out how
            to keep two kids and a packed travel schedule from falling apart at
            the seams. My wife would say I treat everything like an engineering
            problem. She&apos;s not wrong. I&apos;ve spent my career scaling
            teams, driving platform and CI/CD transformations, and now helping
            organizations navigate the shift to AI-driven engineering — where
            the tools are smarter and the pace is relentless. Everything worth
            doing has layers. I like finding them.
          </p>
          <p>
            My background spans front-end, API development, and DevOps with a
            current emphasis on building platform that enable teams to move
            faster and reduce toil. I care deeply about mentoring and creating
            engineering cultures where good outcomes are the natural result of
            clear goals, the right tooling and a good debate.
          </p>
          <p>
            Currently, I serve as Managing Director at Ernst &amp; Young (EY),
            where I lead the Cloud Engineering and DevSecOps Competency and
            serve as a Delivery Leader within Software Engineering. In these
            roles, I help clients solve challenging technology challenges across
            cloud and on-premises environments, design cloud-native developer
            platforms, establish reusable CI/CD pipelines, and build performant
            and scalable applications using microservices architectures.
            Previously, I founded Kartografer LLC to help teams adopt DevOps and
            automation, worked in multiple engineering and leadership roles
            including principal engineer and engineering manager roles. My
            career began in web development which transitioned to API
            development and has since has focused on platform engineering,
            automation, and scaling reliable delivery for product teams.
          </p>
        </div>
      </div>
    </section>
  )
}
